import { useEffect, useState } from "react";

// Re-renders the caller once per interval so time-derived values (e.g. route
// staleness) move on without any data change.
export default function useMinuteTick(intervalMs = 60_000) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return tick;
}
